const toggleableContainers = document.querySelectorAll('[data-toggle-container]');
if (toggleableContainers && toggleableContainers.length) {
  toggleableContainers.forEach((container) => setToggleableContent(container));
}

function setToggleableContent(container) {
  const shown = container.dataset.hasOwnProperty('shown') ? container.dataset.shown : 'toggle-default-shown';
  const hidden = container.dataset.hasOwnProperty('hidden') ? container.dataset.hidden : 'toggle-default-hidden';
  const hash = container.dataset.hasOwnProperty('hash') ? true : false;
  const hasHash = hash && window.location.hash;
  const items = container.querySelectorAll('[data-toggle-item]');

  items.forEach((item) => {
    const trigger = item.querySelector('[data-toggle]');
    if (!trigger) return;
    const target = container.querySelector(`[data-toggle-item='${trigger.dataset.toggle}']`);
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      item.classList.replace(shown, hidden);
      if (!target) return;
      target.classList.replace(hidden, shown);
    });
    if (!hasHash || !item.dataset.hasOwnProperty('hash') || item.dataset.hash !== window.location.hash) return;
    const current = container.querySelector(`.${shown}[data-toggle-item]`);
    if (current) current.classList.replace(shown, hidden);
    item.classList.replace(hidden, shown);
  });
}
